module.exports = __webpack_public_path__ + "static/media/24.ffcb34ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/24.jpg
// module id = 714
// module chunks = 0